import { LicenseManager as AgChartsLicenseManager } from 'ag-charts-enterprise';
import { LicenseManager as AgGridLicenseManager } from 'ag-grid-enterprise';

const SEEQ_AG_ENTERPRISE_LICENSE_KEY =
  'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-115581}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Seeq_Corporation_(USA,_WA,_78762)}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Seeq}_only_for_{36}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Seeq}_need_to_be_licensed___{Seeq}_has_been_granted_a_Deployment_License_Add-on_for_{Unlimited}_Production_Environments___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{28_February_2027}____[v3]_[0102]_MTgwMzc3MjgwMDAwMA==5b7fb7d0402fe572dc827373c17bf2f0';

let agChartsLicenseInitialized = false;
let agGridLicenseInitialized = false;

export const initializeSeeqAgChartsEnterpriseLicense = () => {
  if (agChartsLicenseInitialized) {
    return;
  }

  AgChartsLicenseManager.setLicenseKey(SEEQ_AG_ENTERPRISE_LICENSE_KEY);
  agChartsLicenseInitialized = true;
};

export const initializeSeeqAgGridEnterpriseLicense = () => {
  if (agGridLicenseInitialized) {
    return;
  }

  AgGridLicenseManager.setLicenseKey(SEEQ_AG_ENTERPRISE_LICENSE_KEY);
  agGridLicenseInitialized = true;
};
